<app-vendor-form-wrapper
  data-testid="vendor-add-form-wrapper"
  #formWrapper
  mode="add"
></app-vendor-form-wrapper>

